// File: frontend/src/pages/SuperAdmin/components/common/SuperAdminCard/index.js

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import styles from './SuperAdminCard.module.css';

const SuperAdminCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  trend, 
  format, 
  status,
  color = 'primary',
  onClick,
  actionText,
  actionIcon = faArrowRight,
  loading = false
}) => {
  const getStatusClass = () => {
    if (status === 'success') return styles.success;
    if (status === 'warning') return styles.warning;
    if (status === 'danger') return styles.danger;
    return '';
  };
  
  const getColorClass = () => {
    switch (color) {
      case 'success': return styles.colorSuccess;
      case 'warning': return styles.colorWarning;
      case 'danger': return styles.colorDanger;
      case 'info': return styles.colorInfo;
      default: return styles.colorPrimary;
    }
  };
  
  const formatValue = () => {
    if (loading) return '-';
    
    if (format === 'currency') {
      return new Intl.NumberFormat('en-US', { 
        style: 'currency', 
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    }
    
    return value;
  };
  
  return (
    <div className={`${styles.card} ${getStatusClass()}`}>
      <div className={styles.cardHeader}>
        <h3 className={styles.title}>{title}</h3>
        <div className={`${styles.iconContainer} ${getColorClass()}`}>
          <FontAwesomeIcon icon={icon} className={styles.icon} />
        </div>
      </div>
      
      <div className={styles.cardContent}>
        <div className={styles.valueContainer}>
          <p className={styles.value}>{formatValue()}</p>
          {trend && (
            <span className={`${styles.trend} ${trend > 0 ? styles.positive : styles.negative}`}>
              {trend > 0 ? '+' : ''}{trend}%
            </span>
          )}
        </div>
        
        {subtitle && (
          <p className={styles.subtitle}>{subtitle}</p>
        )}
      </div>
      
      {onClick && actionText && (
        <div className={styles.cardFooter}>
          <button className={styles.actionButton} onClick={onClick}>
            <span>{actionText}</span>
            <FontAwesomeIcon icon={actionIcon} className={styles.actionIcon} />
          </button>
        </div>
      )}
    </div>
  );
};

export default SuperAdminCard;